import { createSlice } from "@reduxjs/toolkit";
import { updateHomeVisitSchedule } from "../../reducer/homeVisitSchedule/updateHomeVisitScheduleReducer";

const initialState = {
  data: {
    schedules: [],
    leaves: [],
  },
  isLoading: false,
  error: null,
};

const updateHomeVisitScheduleSlice = createSlice({
  name: "updateHomeVisitSchedule",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updateHomeVisitSchedule.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateHomeVisitSchedule.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload?.data || {
          schedules: [],
          leaves: [],
        };
      })
      .addCase(updateHomeVisitSchedule.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export default updateHomeVisitScheduleSlice.reducer;
